import React from 'react';
import { StyledModalBody } from './styles';

export type ModalBodyProps = React.HTMLAttributes<HTMLDivElement> & { className?: string };

const ModalBody: React.FC<ModalBodyProps> = ({ className = '', children, ...otherProps }) => (
    <StyledModalBody className={`rui-modal-body ${className}`.trim()} {...otherProps}>
        {children}
    </StyledModalBody>
);

export default ModalBody;
